import clsx from 'clsx';
import s from './Button.module.scss';

const Button = ({
  label,
  onClick,
  fullWidth = false,
  variant = 'primary',
  disabled = false,
  type = 'button',
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        s.button,
        s[variant],
        fullWidth && s.fullWidth,
        disabled && s.disabled
      )}
    >
      {label}
    </button>
  );
};

export default Button;
